import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { numberToWords } from 'helpers/stringConverter'

export const ELetterServiceCB = ({
  docType,
  previewDetail,
  paramVal,
  ItemIndex,
}) => {
  console.log(previewDetail)
  switch (docType) {
    case 'payment':
      return Object.assign(paramVal, {
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        '[CompanyBankName]':
          previewDetail?.BankAccount?.BankProfile?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!) ?? '',
        '[TransactionDate]': dateFormat(previewDetail?.TransactionDate!) ?? '',
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        '[PayeeName]': previewDetail?.PayeeName! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': ItemIndex + i + 1,
            '[ItemDocDate]': el?.DocDate ? dateFormat(el?.DocDate!) : '',
            '[ItemAccCode]': el?.MasterCOA?.Code! ?? '',
            '[ItemAccDesc]': el?.MasterCOA?.Name! ?? '',
            '[ItemDeptCode]': el?.CostCentre?.Code! ?? '',
            '[ItemDeptName]': el?.CostCentre?.Name! ?? '',
            '[ItemDocNo]': el?.DocNo! ?? '',
            '[ItemRemark]': el?.Remark!,
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[ItemTaxRate]':
              el?.TaxScheme?.TaxSchemeDetail?.length === 1
                ? el?.TaxScheme?.TaxSchemeDetail[0]?.taxRate + '%'
                : el?.TaxRate ?? '',
            '[ItemBaseAmt]': el?.Amount !== '' ? amtStr(el?.Amount!) : '',
            '[ItemTaxAmt]': amtStr(el?.TaxAmt!),
            '[ItemTotalAmt]': el?.DocAmt !== '' ? amtStr(el?.DocAmt!) : '',
          }
        }),
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt!),
        '[SumTotalAmtWord]': numberToWords(previewDetail?.DocAmt!),
        // Exempted Tax Summary Info
        exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
          return {
            '[ExemptedTaxReason]': el?.taxExemptionReason! ?? '',
            '[ExemptedTaxCode]': el?.taxExemptionCode! ?? '',
            '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount!) ?? '',
            '[ExemptedTaxRate]': el?.taxExemptionRate! ?? '',
          }
        }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? previewDetail?.TaxExemptionInfo?.reduce(
                (a, b) => a + Number(b?.taxExemptionAmount),
                0
              )
            : '',
      })
    case 'receipt':
      return Object.assign(paramVal, {
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        '[CompanyBankName]':
          previewDetail?.BankAccount?.BankProfile?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!) ?? '',
        '[TransactionDate]': dateFormat(previewDetail?.TransactionDate!) ?? '',
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        '[ReceivedFrom]': previewDetail?.ReceivedFrom! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        items: previewDetail?.itemList?.map((el, i) => {
          return {
            '[Index]': ItemIndex + i + 1,
            '[ItemDocDate]': el?.DocDate ? dateFormat(el?.DocDate!) : '',
            '[ItemRemark]': el?.Remark! ?? '',
            '[ItemTaxExemptionReason]': el?.TaxExemptionReason! ?? '',
            '[ItemAccCode]': el?.MasterCOA?.Code! ?? '',
            '[ItemAccDesc]': el?.MasterCOA?.Name! ?? '',
            '[ItemDeptCode]': el?.CostCentre?.Code! ?? '',
            '[ItemDeptName]': el?.CostCentre?.Name! ?? '',
            '[ItemTaxRate]':
              el?.TaxScheme?.TaxSchemeDetail?.length === 1
                ? el?.TaxScheme?.TaxSchemeDetail[0]?.taxRate + '%'
                : el?.TaxRate ?? '',
            '[ItemBaseAmt]': el?.Amount !== '' ? amtStr(el?.Amount!) : '',
            '[ItemTaxAmt]': amtStr(el?.TaxAmt!),
            '[ItemTotalAmt]': el?.DocAmt !== '' ? amtStr(el?.DocAmt!) : '',
          }
        }),
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt!),
        '[SumTotalAmtWord]': numberToWords(previewDetail?.DocAmt!),
        // Exempted Tax Summary Info
        exemptedTaxItem: previewDetail?.TaxExemptionInfo?.map(el => {
          return {
            '[ExemptedTaxReason]': el?.taxExemptionReason! ?? '',
            '[ExemptedTaxCode]': el?.taxExemptionCode! ?? '',
            '[ExemptedTaxAmount]': amtStr(el?.taxExemptionAmount!) ?? '',
            '[ExemptedTaxRate]': el?.taxExemptionRate! ?? '',
          }
        }),
        '[TotalTaxExemptionAmount]':
          previewDetail?.TaxExemptionInfo?.length > 0
            ? previewDetail?.TaxExemptionInfo?.reduce(
                (a, b) => a + Number(b?.taxExemptionAmount),
                0
              )
            : '',
      })
    case 'bank-transfer':
      Object.assign(paramVal, {
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]':
          dateFormat(previewDetail?.DocDate! ?? previewDetail?.TransferDate!) ??
          '',
        '[TransferDate]': dateFormat(previewDetail?.TransferDate!) ?? '',
        '[TransactionDate]': dateFormat(previewDetail?.TransactionDate!),
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        '[ToBankAcc]': previewDetail?.itemList?.BankName ?? '',
        '[FromBankAcc]': previewDetail?.FromBankAccountDetail?.BankName ?? '',
        '[ToBankAccNo]': previewDetail?.itemList?.AccountNo ?? '',
        '[FromBankAccNo]':
          previewDetail?.FromBankAccountDetail?.AccountNo ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[FromBankCode]': previewDetail?.FromBankAccountDetail?.Code! ?? '',
        '[ToBankCode]': previewDetail?.itemList?.Code! ?? '',
        '[TotalAmt]': amtStr(previewDetail?.Amount!),
        '[TotalAmtWord]': numberToWords(previewDetail?.Amount!),
      })
  }
}
